module.exports = __webpack_public_path__ + "static/media/callUnmute.5e99863e.svg";